import { useQuery } from '@tanstack/react-query';
import config from '../../../../../../config/config';
import Fetch from '../../../../../../util/core/Fetch';
import { useUserCity } from '../../../../Common/hooks/useUserCity';
import { getUserSession } from '../../../../../../util/core/Session';

const useHealthUnits = (cityId) => {
    const { data } = useUserCity();
    const session = getUserSession();

    const profile = session.user.application_profile_id;

    const isCityManager =
        profile === config.default_foreign_key.sdg_profiles.cityManager;

    const city = isCityManager ? data?.governance_room_geo_city_id : cityId;

    return useQuery({
        queryKey: ['health-units', city],
        queryFn: async () => {
            return await Fetch.post(
                config.endpoints.backend + 'governanceroom/esus/gethealthunits',
                {
                    filters: {
                        governance_room_geo_city_id: city,
                    }
                }
            );
        },
        staleTime: Infinity,
        enabled: !!city
    });
};

export default useHealthUnits;
